window.process = {};
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './assets/styles/allStyles.scss';
import { store } from './store';
import {
    DrawerContextProvider,
    initAxiosInterceptors,
    AllModals,
    ModalProvider,
    SecondaryModalProvider,
    SecondaryModals,
    BaseModalProvider,
    BaseModals,
} from 'utils';
import { ScrollToTop } from './utils/hooks';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
import { initSentry, Sentry, setSentryUserContextFromToken } from './utils/sentry';
import { getToken } from './utils/crypto';

// "ResizeObserver loop completed with undelivered notifications" is a benign browser notice — it fires when an
// observed element resizes again within the same frame (e.g. the HubSpot support form's auto-sizing iframe). Nothing
// breaks, but the dev overlay renders it as a fatal error. Capture phase, so this runs before the overlay's listener;
// only this exact message is swallowed, every other error still surfaces.
window.addEventListener(
    'error',
    (event) => {
        if (/^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/.test(event.message || '')) {
            event.stopImmediatePropagation();
        }
    },
    true,
);

initSentry();
setSentryUserContextFromToken(getToken());

const theme = createTheme();

initAxiosInterceptors();

const ErrorFallback = () => (
    <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
        <h2>Something went wrong.</h2>
        <p>The error has been reported. Please refresh the page.</p>
    </div>
);

const root = createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    // <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
    <Sentry.ErrorBoundary showDialog={false}>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <HelmetProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <Provider store={store}>
                            <DrawerContextProvider>
                                <ModalProvider>
                                    <SecondaryModalProvider>
                                        <BaseModalProvider>
                                            <App />
                                            <AllModals />
                                            <SecondaryModals />
                                            <BaseModals />
                                        </BaseModalProvider>
                                    </SecondaryModalProvider>
                                </ModalProvider>
                            </DrawerContextProvider>
                        </Provider>
                    </BrowserRouter>
                </HelmetProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    </Sentry.ErrorBoundary>
    // </React.StrictMode>,
);

// reportWebVitals();
serviceWorkerRegistration.register();
// serviceWorkerRegistration.register();
